import React, { useState, useEffect } from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import moment from "moment"
import toast from "react-hot-toast"
import cleanLogo from "../../Assets/Images/Login/logo.png"
import Navbar from "../../Components/Navbar/Navbar"
import { numberFormat, refreshPage, toastStyle } from "../../Helpers/Utils/Common"
import { getStatementOfAccount } from "../../Helpers/apiCalls/StatementOfAccount/StatementOfAccountApi"
import "../ProjectInvoice/ProjectInvoice.css" // reusing print style
import "./StatementOfAccount.css" 

export default function PrintStatementOfAccount() {
  const { id } = useParams()
  const location = useLocation()
  const navigate = useNavigate()

  const passed = location.state?.soa
  const from = location.state?.from 
  const to = location.state?.to

  const [inactive, setInactive] = useState(true)
  const [logoData, setLogoData] = useState(cleanLogo)
  const [soa, setSoa] = useState(
    passed || {
      client_name: "",
      project_name: "",
      address: "",
      beginning_balance: 0,
      total_billings: 0,
      total_payment: 0,
      ending_balance: 0,
      account_current_balance: 0,
      notes: "",
      items: [],
    }
  )

  useEffect(() => {
    if (passed) return 
    fetchStatementOfAccount()
  }, [id, passed])

  async function fetchStatementOfAccount() {
    const response = await getStatementOfAccount({
      id,
      date_from: from || null,
      date_to: to || null,
    })
    if (response?.data) {
      const d = response.data.data ?? response.data ?? {}
      setSoa({
        client_name: d.client_name ?? "",
        project_name: d.project_name ?? "",
        address: d.address ?? "",
        beginning_balance: d.beginning_balance ?? 0,
        total_billings: d.total_billings ?? 0,
        total_payment: d.total_payment ?? 0,
        ending_balance: d.ending_balance ?? 0,
        account_current_balance: d.account_current_balance ?? 0,
        notes: d.notes ?? "",
        items: d.items ?? [],
      })
    }
  }

  useEffect(() => {
    fetch(cleanLogo)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader()
        reader.onloadend = () => setLogoData(reader.result)
        reader.readAsDataURL(blob)
      })
      .catch(() => {})
  }, [])

  const money = (v) => (v || v === 0 ? numberFormat(Number(v).toFixed(2)) : "")

  function periodLabel() {
    if (from && to) {
      return `${moment(from).format("MMMM YYYY")} to ${moment(to).format("MMMM YYYY")}`
    }
    return "Whole duration"
  }

  function handlePrint() {
    toast.loading("Generating statement of account...", { style: toastStyle() })
    setTimeout(() => {
      toast.dismiss()
      document.title = `SOA - ${soa.project_name || id}`
      Print()
      document.title = "MYT"
    }, 1000)
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  const firstTable = () => {
    return (
      <div className="app-container">
        <table>
          <thead>
            <tr>
              <th
                className="text-left custom-td header-style"
                colSpan="2"
                style={{ fontSize: "20px" }}
              >
                Client Details:
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-left custom-td" style={{ fontSize: "20px" }}>
                Client Name
              </td>
              <td className="print-data text-left custom-td" style={{ fontSize: "20px" }}>
                {soa.client_name}
              </td>
            </tr>
            <tr>
              <td className="text-left custom-td" style={{ fontSize: "20px" }}>
                Project Name
              </td>
              <td className="print-data text-left custom-td" style={{ fontSize: "20px" }}>
                {soa.project_name}
              </td>
            </tr>
            <tr>
              <td className="text-left custom-td" style={{ fontSize: "20px" }}>
                Address
              </td>
              <td className="print-data text-left custom-td" style={{ fontSize: "20px" }}>
                {soa.address}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  const secondTable = () => {
    return (
      <div className="app-container">
        <table>
          <thead>
            <tr>
              <th className="custom-td header-style" style={{ fontWeight: "bold", fontSize: "20px" }}>
                Date
              </th>
              <th className="custom-td header-style" style={{ fontWeight: "bold", fontSize: "20px" }}>
                Billing No.
              </th>
              <th className="custom-td header-style" style={{ fontWeight: "bold", fontSize: "20px" }}>
                Description
              </th>
              <th className="custom-td header-style" style={{ fontWeight: "bold", fontSize: "20px" }}>
                Debit (₱)
              </th>
              <th className="custom-td header-style" style={{ fontWeight: "bold", fontSize: "20px" }}>
                Credit (₱)
              </th>
              <th className="custom-td header-style" style={{ fontWeight: "bold", fontSize: "20px" }}>
                Balance (₱)
              </th>
            </tr>
          </thead>
          <tbody>
            {soa.items.map((t, index) => {
              return (
                <tr key={index}>
                  <td className="custom-desc-td" style={{ fontSize: "18px" }}>
                    {t.date ? moment(t.date).format("D MMM yyyy") : ""}
                  </td>
                  <td className="custom-desc-td" style={{ fontSize: "18px" }}>
                    {t.type === "invoice" ? t.billing_no : ""}
                  </td>
                  <td className="custom-desc-td" style={{ fontSize: "18px" }}>
                    {t.description}
                  </td>
                  <td className="custom-num-td" style={{ fontSize: "18px", color: "black" }}>
                    {money(t.debit)}
                  </td>
                  <td className="custom-num-td" style={{ fontSize: "18px", color: "black" }}>
                    {money(t.credit)}
                  </td>
                  <td className="custom-num-td" style={{ fontSize: "18px", color: "black" }}>
                    {money(t.balance)}
                  </td>
                </tr>
              )
            })}
            <tr>
              <td colSpan={6} style={{border: "none", height: "48px"}}></td>
            </tr>

            <tr>
              <td
                className="text-end custom-td"
                style={{ fontSize: "18px", border: "none", fontWeight: "bold" }}
                colSpan={5}
              >
                Beginning Balance
              </td>
              <td className="text-right custom-td" style={{ fontSize: "18px" }}>
                {money(soa.beginning_balance)}
              </td>
            </tr>
            <tr>
              <td
                className="text-end custom-td"
                style={{ fontSize: "18px", border: "none", fontWeight: "bold" }}
                colSpan={5}
              >
                Total Billings
              </td>
              <td className="text-right custom-td" style={{ fontSize: "18px" }}>
                {money(soa.total_billings)}
              </td>
            </tr>
            <tr>
              <td
                className="text-end custom-td"
                style={{ fontSize: "18px", border: "none", fontWeight: "bold" }}
                colSpan={5}
              >
                Total Payment
              </td>
              <td className="text-right custom-td" style={{ fontSize: "18px" }}>
                {money(soa.total_payment)}
              </td>
            </tr>
            <tr>
              <td
                className="text-end custom-td"
                style={{ fontSize: "18px", border: "none", fontWeight: "bold" }}
                colSpan={5}
              >
                Ending Balance
              </td>
              <td className="text-right custom-td" style={{ fontSize: "18px" }}>
                {money(soa.ending_balance)}
              </td>
            </tr>
            <tr>
              <td
                className="text-end custom-td"
                style={{ fontWeight: "bold", fontSize: "20px", border: "none" }}
                colSpan={5}
              >
                ACCOUNT CURRENT BALANCE
              </td>
              <td className="text-right custom-td" style={{ fontWeight: "bold", fontSize: "20px" }}>
                {money(soa.account_current_balance)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"FINANCIAL REPORT"}
        />
      </div>
      <div className={`container ${inactive ? "inactive" : "active"}`}>
        <div className="print-container px-3 py-2" id="printablediv">
          <table className="soa-page">
            <thead className="soa-running-head">
              <tr>
                <td style={{ border: "none", padding: 0 }}>
          <div className="text-start print-header d-flex flex-column"></div>
          <div>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="text-left">
                    <img
                      src={logoData}
                      className="print-logo"
                      alt="Logo"
                      style={{ width: "200px", height: "70px" }}
                    />
                  </div>
                  <div className="text-end">
                    <div>
                      <span
                        style={{
                          fontSize: "80px",
                          color: "#5ac8e1",
                          fontWeight: "bold",
                          lineHeight: "1.1",
                        }}
                      >
                        STATEMENT
                        <br />
                        OF ACCOUNT
                      </span>
                    </div>
                  </div>
                </div>

                <div className="text-left">
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontSize: "30px", fontWeight: "bold" }}>
                      MYT SoftDev Solutions, Inc.
                    </span>
                    <span style={{ fontSize: "30px", fontWeight: "bold" }}>
                      NO. {id}
                    </span>
                  </div>
                </div>

                <div className="text-left">
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontSize: "16px" }}>
                      301 The Greenery, Pope John Paul II Ave.
                    </span>
                  </div>
                </div>

                <div style={{ fontSize: "16px" }}>Cebu City, 6000 Cebu</div>
                <div style={{ fontSize: "16px" }}>
                  <a href="mailto:billings@mytdevcorp.com">billings@mytdevcorp.com</a>
                </div>

                <div className="text-left mt-3">
                  <div className="d-flex justify-content-between">
                    <span></span>
                    <span className="text-uppercase" style={{ fontSize: "18px" }}>
                      {"STATEMENT DATE: " + moment().format("MMMM DD, yyyy")}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span></span>
                    <span className="text-uppercase" style={{ fontSize: "18px" }}>
                      {"PERIOD: " + periodLabel()}
                    </span>
                  </div>
                </div>
              </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "none", padding: 0 }}>
          <div className="d-flex mt-5 mb-2">
            <div className="print-table mt-3 mx-2">{firstTable()}</div>
          </div>
          <div className="d-flex mt-5 mb-2">
            <div className="print-table mt-3 mx-2">{secondTable()}</div>
          </div>

          <div className="soa-doc-footer">
            {soa.notes ? (
              <div
                className="text-left"
                style={{ fontSize: "20px", textTransform: "uppercase" }}
              >
                NOTES: {soa.notes}
              </div>
            ) : null}

            <div
              className="text-left"
              style={{ fontSize: "20px", paddingTop: "20px", paddingBottom: "20px" }}
            >
              <span>
                For check payment, deposit payment to:
                <div>Bank Name: Banco de Oro (BDO) Cebu HM Tower</div>
                <div>Account Number: 013030014422</div>
                <div>Account Name: MYT SoftDev Solutions, Inc.</div>
              </span>
            </div>
          </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-end my-4 pb-5 d-flex-responsive">
          <button
            className="button-secondary me-3"
            onClick={() => navigate("/statement-of-account")}
          >
            Close
          </button>
          <button className="button-primary" onClick={handlePrint}>
            Generate
          </button>
        </div>
      </div>
    </div>
  )
}
